<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 my-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
</p-card>

<div *ngIf="EstCharge() && !modePopup" class="grid">
    <div class="col-12">
        <p-card>
            <h5>{{nonConformite.numero}}
                <span [class]="'statut ' + nonConformite.statut.nom.toLowerCase()">
                    {{nonConformite.statut.nom}}
                </span>
            </h5>

            <p-menubar [model]="menu" [autoDisplay]="false">
                <p-button *ngIf="modeConsultation()" (click)="Modifier()" icon="pi pi-pencil"
                    styleClass="p-button-primary"></p-button>
                <p-button *ngIf="modeModification()" (onClick)="enregistrerModifications()" label icon="pi pi-check"
                    styleClass="p-button-success mr-2">
                </p-button>
                <p-button *ngIf="modeModification()" (onClick)="Consulter()" icon="pi pi-times"
                    styleClass="p-button-secondary"></p-button>
            </p-menubar>
        </p-card>
    </div>
</div>

<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <p-tabView [scrollable]="true" #tabView [(activeIndex)]="tabIndex" (onChange)="surChangementOnglet($event)">

                <p-messages *ngIf="this.nonConformite.actionCorrectives.length > 0" severity="info">
                    <ng-template pTemplate>
                        <div class="flex justify-content-between align-items-center" style="width: 100%;">
                            <div class="ml-2">Cette non-conformité a reçu une demande d'action corrective.</div>
                            <button pButton label="Voir l'action corrective" icon="pi pi-eye" class="ml-2"
                                (click)="voirActionCorrective(nonConformite.actionCorrectives[0].actionCorrectiveId)"></button>
                        </div>
                    </ng-template>
                </p-messages>

                <!-- Informations générales -->
                <p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
                    <p-panel styleClass="mb-6">
                        <ng-template pTemplate="header">
                            <div class="flex align-items-center gap-2">
                                <i class="pi pi-info-circle" style="font-size: 1rem;" ></i>
                                <h6 class="m-0">Général</h6>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="content">
                            <div class="fluid formgrid grid">
                                <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
                                    <label for="type">Catégorie<span class="requis">*</span></label>
                                    <p-dropdown [options]="types" [(ngModel)]="nonConformite.type" optionValue="id"
                                        optionLabel="nom" [disabled]="modeConsultation()" [required]="true">
                                    </p-dropdown>
                                </div>
                                <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
                                    <label for="codeProjet">Projet<span class="requis">*</span></label>
                                    <p-dropdown [options]="codeProjets" [(ngModel)]="nonConformite.codeProjet.codeProjetId"
                                        optionValue="codeProjetId" optionLabel="nom" [disabled]="modeConsultation()"
                                        [required]="true">
                                    </p-dropdown>
                                </div>
                                <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
                                    <label for="dateEmission">Date de création</label>
                                    <input id="dateEmission" type="text" pInputText
                                        value="{{nonConformite.dateEmission | date:'yyyy-MM-dd'}}" [readOnly]="true">
                                </div>
                                <div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
                                    <label for="dateDetection">Date de détection</label>
                                    <div class="p-inputgroup">
                                        <p-calendar *ngIf="modeModification()" [(ngModel)]="nonConformite.dateDetection"
                                            dateFormat="yy-mm-dd" [showIcon]="true"></p-calendar>
                                        <input *ngIf="modeConsultation()" id="dateDetection" type="text" pInputText
                                            value="{{nonConformite.dateDetection | date:'yyyy-MM-dd'}}" [readOnly]="true">
                                        <button *ngIf="modeModification()" pButton type="button" icon="pi pi-copy" 
                                            (click)="copierDateEmission()" 
                                            pTooltip="Copier la date d'émission" tooltipPosition="top"></button>
                                    </div>
                                </div>
                                <div class="flex flex-column gap-2 my-2 col-12">
                                    <label for="titre">Titre<span class="requis">*</span></label>
                                    <input id="titre" type="text" pInputText [(ngModel)]="nonConformite.titre"
                                        [readonly]="modeConsultation()" [required]="true">
                                </div>
                                <div class="flex flex-column gap-2 my-2 col-12">
                                    <label for="description">Description</label>
                                    <textarea id="description" pInputTextarea [(ngModel)]="nonConformite.description"
                                        [readonly]="modeConsultation()" rows="5" style="resize: vertical;"></textarea>
                                </div>
                            </div>
                        </ng-template>
                    </p-panel>

                    <p-panel styleClass="mb-6">
                        <ng-template pTemplate="header">
                            <div class="flex align-items-center gap-2">
                                <i class="pi pi-users" style="font-size: 1rem;"></i>
                                <h6 class="m-0">Intervenants</h6>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="content">
                            <div class="fluid formgrid grid">
                                <div class="flex flex-column gap-2 my-2 col-12 md:col-6">
                                    <label for="entrepreneur">Créateur de la non-conformité</label>
                                    <span class="p-inputtext p-component"><app-employe-avec-emplacement [employe]="nonConformite.employe"></app-employe-avec-emplacement></span>
                                </div>
                                <div class="flex flex-column gap-2 my-2 col-12 md:col-6">
                                    <label for="coordonnateur">Responsable qualité</label>
                                    <span *ngIf="modeConsultation()" class="p-inputtext p-component"><app-employe-avec-emplacement [employe]="nonConformite.coordonateur"></app-employe-avec-emplacement></span>
                                    <p-dropdown *ngIf="modeModification()" [options]="employes" [(ngModel)]="nonConformite.coordonateur" optionLabel="nom" [loading]="!employes"
                                        appendTo="body" [showClear]="true" filter="true" filterBy="nom,prenom" 
                                        placeholder="Sélectionner un responsable...">
                                        <ng-template pTemplate="selectedItem" let-employe>
                                            {{employe | nomEmploye}}
                                        </ng-template>
                                        <ng-template pTemplate="item" let-employe>
                                            {{employe | nomEmploye}}
                                        </ng-template>
                                    </p-dropdown>
                                </div>
                                <div class="flex flex-column gap-2 my-2 col-12 md:col-4">
                                    <div class="flex flex-column gap-2 my-2 col-12">
                                        <label for="entrepreneur">Entrepreneur</label>
                                        <input id="entrepreneur" pInputText [(ngModel)]="nonConformite.entrepreneur"
                                            [readonly]="modeConsultation()" rows="5">
                                    </div>
                                    <div class="flex flex-column gap-2 my-2 col-12">
                                        <label for="responsableQualite">Responsable qualité / SST / Environnement</label>
                                        <input id="responsableQualite" pInputText [(ngModel)]="nonConformite.responsableQualite"
                                            [readonly]="modeConsultation()" rows="5">
                                    </div>
                                </div>
        
                                <div class="flex flex-column gap-2 my-2 col-12 md:col-4">
                                    <div class="flex flex-column gap-2 my-2 col-12">
                                        <label for="sousTraitant">Sous-traitant</label>
                                        <p-inputGroup>
                                            <input *ngIf="modeConsultation()" id="sousTraitant" pInputText [ngModel]="nonConformite.sousTraitant?.nom">
                                            <p-dropdown *ngIf="modeModification()" [options]="fournisseurs" [(ngModel)]="nonConformite.sousTraitant" optionLabel="nom" [loading]="!fournisseurs"
                                                appendTo="body" [showClear]="true" filter="true" filterBy="nom" 
                                                placeholder="Sélectionner un sous-traitant...">
                                                <ng-template pTemplate="selectedItem" let-fournisseur>
                                                    {{fournisseur.nom}}
                                                </ng-template>
                                            </p-dropdown>
                                            <button *ngIf="nonConformite.sousTraitant?.fournisseurId" pButton type="button" icon="pi pi-external-link" 
                                                [routerLink]="['/fournisseur', nonConformite.sousTraitant.fournisseurId]"></button>
                                        </p-inputGroup>
                                    </div>
                                    <div class="flex flex-column gap-2 my-2 col-12">
                                        <label for="representant">Représentant {{nonConformite.sousTraitant?.nom}}</label>
                                        <input id="representant" pInputText [(ngModel)]="nonConformite.representant"
                                            [readonly]="modeConsultation()" rows="5">
                                    </div>
                                </div>
        
                                <div class="flex flex-column gap-2 my-2 col-12 md:col-4">
                                    <div class="flex flex-column gap-2 my-2 col-12">
                                        <label for="client">Client</label>
                                        <input id="client" pInputText [(ngModel)]="nonConformite.client"
                                            [readonly]="modeConsultation()" rows="5">
                                    </div>
                                    <div class="flex flex-column gap-2 my-2 col-12">
                                        <label for="representantClient">Représentant {{nonConformite.client}}</label>
                                        <input id="representantClient" pInputText [(ngModel)]="nonConformite.representantClient"
                                            [readonly]="modeConsultation()" rows="5">
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </p-panel>

                    <p-panel styleClass="mb-6">
                        <ng-template pTemplate="header">
                            <div class="flex align-items-center gap-2">
                                <i class="pi pi-list-check" style="font-size: 1rem;"></i>
                                <h6 class="m-0">Détails</h6>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="content">
                            <div class="fluid formgrid grid">
                                <div class="flex flex-column gap-2 my-2 col-12">
                                    <label for="causesPossibles">Causes possibles</label>
                                    <textarea id="causesPossibles" pInputTextarea [(ngModel)]="nonConformite.causesPossibles"
                                        [readonly]="modeConsultation()" rows="5" style="resize: vertical;"></textarea>
                                </div>
                            </div>
        
                            <div class="fluid formgrid grid">
                                <div class="flex flex-column gap-4 my-2 col-12 md:col-4">
                                    <label for="typeNonConformite">Type de non-conformité</label>
                                    <input id="typeNonConformite" pInputText [(ngModel)]="nonConformite.objet"
                                        [readonly]="modeConsultation()" rows="5">
                                </div>
                                <div class="flex flex-column gap-4 my-2 col-12 md:col-4">
                                    <label for="responsable">Responsable</label>
                                    <input id="responsable" pInputText [(ngModel)]="nonConformite.responsable"
                                        [readonly]="modeConsultation()" rows="5">
                                </div>
                                <div class="flex flex-column gap-4 my-2 col-12 md:col-4">
                                    <label for="document">Documents</label>
                                    <p-floatLabel>
                                        <input id="noArticle" type="text" pInputText [(ngModel)]="nonConformite.noArticle"
                                            [readonly]="modeConsultation()" />
                                        <label for="noArticle">N° Article</label>
                                    </p-floatLabel>
                                    <p-floatLabel>
                                        <input id="noPlan" type="text" pInputText [(ngModel)]="nonConformite.noPlan"
                                            [readonly]="modeConsultation()" />
                                        <label for="noPlan">N° Plan</label>
                                    </p-floatLabel>
                                    <p-floatLabel>
                                        <input id="noBonCommande" type="text" pInputText
                                            [(ngModel)]="nonConformite.noBonCommande" [readonly]="modeConsultation()" />
                                        <label for="noBonCommande">N° Bon de commande</label>
                                    </p-floatLabel>
                                    <p-floatLabel>
                                        <input id="noPiece" type="text" pInputText [(ngModel)]="nonConformite.noPiece"
                                            [readonly]="modeConsultation()" />
                                        <label for="noPiece">N° Pièce</label>
                                    </p-floatLabel>
                                </div>
                            </div> 
                        </ng-template>
                    </p-panel>
                    

                </p-tabPanel>

                <p-tabPanel [disabled]="nonConformite.statut.statutId != EStatuts.Traite" header="Traitement" 
                leftIcon="pi pi-list-check" 
                [tooltip]="this.nonConformite.statut.statutId == EStatuts.Nouveau ? 'Cette non-conformité n\'est pas encore traitée. Veuillez la complétée avec le menu actions.' : ''" 
                tooltipPosition="top" >
                    <ng-template pTemplate="content">
                        <app-approbation-non-conformite [nonConformite]="nonConformite" [isModeConsultation]="modeConsultation()" (onViewDocuments)="VoirDocumentsTraitement()"></app-approbation-non-conformite>
                    </ng-template>
                </p-tabPanel>

                <p-tabPanel [header]="'Suivi (' + (nonConformite.nbSuivis ?? 0) + ')'" leftIcon="pi pi-comments" >
                    <ng-template pTemplate="content">
                        <div class="remaining-height">
                            <app-fil-conversation [conversationId]="nonConformite.conversationId"></app-fil-conversation>
                        </div>
                    </ng-template>
                </p-tabPanel>

                <p-tabPanel [header]="'Documents (' + (nonConformite.nbDocuments ?? 0) + ')'" leftIcon="pi pi-file-o">
                    <ng-template pTemplate="content">
                        <app-document [typeLienDocument]="ETypeLienDocument.NonConformite" [idLien]="nonConformiteId" [selectedTreeNode]="'action_corrective'"
                        [numero]="nonConformite.numero" [readonly]="modePopup"></app-document>
                    </ng-template>
                </p-tabPanel>
            </p-tabView>
        </p-card>
    </div>
</div>